export const requestFromNet = (url: string, requestInit?: RequestInit) => {
  const headers: HeadersInit = {};
  if (typeof localStorage !== 'undefined') {
    headers['x-platform'] = 'web-cookie';
  }
  requestInit = {
    ...requestInit,
    headers: { ...requestInit?.headers, ...headers },
  };
  return fetch(location.origin + url, requestInit)
    .then((res) => res.json())
    .then((res) => res);
};
